
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "27",
    "height": "27",
    "viewBox": "0 0 27 27"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "ttnq38uzka"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "values": "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "filter": "url(#ttnq38uzka)",
                "transform": "translate(-1085 -226) translate(952 210)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "fill": "#000",
                    "fill-rule": "nonzero"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M19.35 16.256c1.783-2.25 3.343-4.781 3.343-6.975C22.693 4.163 18.57 0 13.5 0 8.43 0 4.307 4.163 4.307 9.281c0 2.138 1.504 4.669 3.287 6.919-3.565.956-5.794 2.756-5.794 4.613 0 3.43 6.017 5.287 11.7 5.287 5.683 0 11.7-1.856 11.7-5.288 0-1.968-2.173-3.656-5.85-4.556zM13.5 1.687c4.123 0 7.521 3.432 7.521 7.594 0 3.263-5.014 8.438-7.521 10.688-2.507-2.25-7.521-7.425-7.521-10.688 0-4.162 3.342-7.594 7.521-7.594zm0 22.726c-5.739 0-10.029-1.913-10.029-3.6 0-1.013 2.006-2.476 5.349-3.207 2.006 2.306 4.011 3.994 4.179 4.106l.557.45.557-.45c.167-.168 2.117-1.8 4.067-4.05 3.566.732 5.404 2.082 5.404 3.15-.055 1.688-4.345 3.6-10.084 3.6z",
                        "transform": "translate(133 16)"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M13.5 12.6c-1.994 0-3.6-1.606-3.6-3.6s1.606-3.6 3.6-3.6 3.6 1.606 3.6 3.6-1.606 3.6-3.6 3.6zm0-5.538c-1.052 0-1.938.886-1.938 1.938s.83 1.938 1.938 1.938 1.938-.886 1.938-1.938-.886-1.938-1.938-1.938z",
                        "transform": "translate(133 16)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  